import React, { useState } from 'react';
import style from './listaBalneario.module.scss';
import ListaBalnearioItem from './components/listaBalnearioItem/listaBalnearioItem';
import { PaginasOutrosRegimes } from 'interfaces/IBasesCalculo';
import { IBalnearioComBanhoLista, IBalnearioSemBanhoLista } from 'interfaces/IBalneario';

interface IListaBalneariosProps {
  setBaseDeCalculo: React.Dispatch<React.SetStateAction<PaginasOutrosRegimes | ''>>;
  setIsEdicao: React.Dispatch<React.SetStateAction<boolean>>;
  itensComBanho?: IBalnearioComBanhoLista[];
  itensSemBanho?: IBalnearioSemBanhoLista[];
  refetchLista: () => void;
  setIsAdicaoNovaBaseCalculo: React.Dispatch<React.SetStateAction<boolean>>;
  isViewOnly: boolean | undefined;
}

const ListaBalneario = ({
  setBaseDeCalculo,
  setIsEdicao,
  itensComBanho,
  itensSemBanho,
  refetchLista,
  setIsAdicaoNovaBaseCalculo,
  isViewOnly,
}: IListaBalneariosProps) => {
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);

  let contador = 0;

  return (
    <>
      <div
        className={style.accordion}
        onClick={() => setIsAccordionOpen(!isAccordionOpen)}
        onKeyDown={() => setIsAccordionOpen(!isAccordionOpen)}
      >
        <div className={style.leftContainer}>
          <span className={style.iconArrow}>
            {!isAccordionOpen ? (
              <i className={`fas fa-chevron-down fa-sm`} />
            ) : (
              <i className={`fas fa-chevron-up fa-sm`} />
            )}
          </span>
          <div className={style.title}>Balneários</div>
        </div>
        <div className={style.rightContainer}></div>
      </div>
      {isAccordionOpen && (
        <div className={style.accordionContent}>
          {itensComBanho?.map((item) => {
            contador++;
            return (
              <ListaBalnearioItem
                comBanho={true}
                itemComBanho={item}
                index={contador}
                key={item.id}
                setBaseDeCalculo={setBaseDeCalculo}
                setIsEdicao={setIsEdicao}
                refetchLista={refetchLista}
                setIsAdicaoNovaBaseCalculo={setIsAdicaoNovaBaseCalculo}
                isViewOnly={isViewOnly}
              />
            );
          })}
          {itensSemBanho?.map((item) => {
            contador++;
            return (
              <ListaBalnearioItem
                comBanho={false}
                itemSemBanho={item}
                index={contador}
                key={item.id}
                setBaseDeCalculo={setBaseDeCalculo}
                setIsEdicao={setIsEdicao}
                refetchLista={refetchLista}
                setIsAdicaoNovaBaseCalculo={setIsAdicaoNovaBaseCalculo}
                isViewOnly={isViewOnly}
              />
            );
          })}
        </div>
      )}
    </>
  );
};

export default ListaBalneario;
